import { useState } from 'react';

import { ApiError } from '@solar/api-client';

export function Login({ onLogin }: { onLogin: (id: string, pw: string) => Promise<void> }) {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await onLogin(userId.trim(), password);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : '로그인에 실패했습니다.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="login" onSubmit={submit}>
      <h1>미니태양광 관리</h1>
      <label>
        아이디
        <input
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          autoComplete="username"
          autoCapitalize="none"
          required
        />
      </label>
      <label>
        비밀번호
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
      </label>
      {error && <p className="error">{error}</p>}
      <button type="submit" className="primary" disabled={busy || !userId || !password}>
        {busy ? '로그인 중…' : '로그인'}
      </button>
    </form>
  );
}
